import React from 'react'
import Layout from '../components/layout'

import ourClients1 from './images/our-clients-new.png'
import ourClients2 from './images/our-clients2.jpg'
import SEO from '../components/seo'

var OurClients = () => (
  <Layout>
    <SEO title="Our Clients" keywords={[]} />

    <div id="main" role="main">
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Our Clients</h1>
        <div className="float-left" style={{ width: '400px' }}>
          <img
            className="alignleft"
            style={{ float: 'left' }}
            title="Our Clients"
            src={ourClients1}
            height={285}
          />
          <p />
          <ul className="client-list float-left">
            <li>U.S. Olympic Committee</li>
            <li>The National Security Agency</li>
            <li>The Whiffenpoofs of Yale University</li>
            <li>Christie’s Auctions</li>
            <li>General Motors Europe</li>
            <li>U.S. Environmental Protection Agency</li>
            <li>Boston Scientific</li>
            <li>Sun Microsystems</li>
            <li>Motorola</li>
            <li>U.S. Department of Education</li>
            <li>Reeds Jewelers</li>
            <li>McKesson</li>
            <li>The World Economic Forum</li>
            <li>U.S. Department of Homeland Security</li>
            <li>Open Sky Wilderness Therapy</li>
            <li>Deloitte Touche</li>
            <li>Roche Pharmaceuticals</li>
            <li>Consumers Energy</li>
            <li>Anglo American</li>
            <li>Winchester-Frederick Chamber of Commerce-Virginia</li>
            <li>Whole Foods Market</li>
            <li>Anheuser Busch InBev</li>
            <li>Saint Paul’s School for Girls-Baltimore</li>
            <li>U.S. Air Force</li>
          </ul>
        </div>
        <div className="float-left" style={{ width: '400px' }}>
          <div style={{ float: 'left', width: '400px', marginRight: '55px' }}>
            <p
              style={{
                margin: '10px 0 0 0',
                width: '370px',
                paddingLeft: '30px',
              }}
            >
              A partial list of the organizations we have worked with includes:
            </p>
          </div>
          <ul
            className="client-list float-left"
            style={{ paddingLeft: '60px' }}
          >
            <li>Toyota</li>
            <li>Microsoft</li>
            <li>Mars</li>
            <li>The Kaiser Foundation</li>
            <li>U.S. Department of Agriculture</li>
            <li>Bank of America</li>
            <li>National Association of Independent Schools</li>
            <li>Schwarz Biosciences</li>
            <li>Flextronics</li>
            <li>U.S. Office of Personnel Management</li>
            <li>Titleist</li>
            <li>Philip Morris International</li>
            <li>U.S. Department of Defense</li>
            <li>Kraft</li>
            <li>U.S. Consumer Product Safety Commission</li>
            <li>Guidant</li>
            <li>PricewaterhouseCoopers</li>
            <li>Dow Corning</li>
            <li>Kessler Financial Services</li>
            <li>California State University-Los Angeles</li>
            <li>Barrick Gold</li>
            <li>The Lovett School-Atlanta</li>
          </ul>
          <div>
            <img
              className="alignright"
              style={{ float: 'right' }}
              title="Our Clients"
              src={ourClients2}
              height={285}
            />
          </div>
        </div>
        <p>&nbsp;</p>
        <p>
          We also provide services pro bono to select local and national
          non-profits.
        </p>
      </div>
    </div>
  </Layout>
)

export default OurClients
